<mat-dialog-content>
  <div class="p-3">
    <span>Please be aware that this application contains Personal Information. “Personal Information” includes data
      such
      as a person’s name and business information
      such as SSO or GE email address. <br> <br>
      As a user of this application, you agree to comply with GE's Commitment to
      the Protection of Personal Information when handling
      Personal Information and any other information in this application relating to an identified or identifiable
      person. This means, among other things, that you will
      use such information only for legitimate business purposes, arrange for it to be corrected when you know it is
      inaccurate, share it only on a ‘need to know’ basis
      and use reasonable measures to protect it from unauthorized persons.<br><br>
      For more information on your obligations and how GE protects Personal Information see GE’s Privacy Policy
      and supplemental documents at 
      <a href="https://inside.integrity.ge.com">inside.integrity.ge.com</a></span>
  </div>
</mat-dialog-content>
<div class="w-100 d-flex justify-content-center">
  <button class="btn btn-primary btn-save button submit btn-vernova" (click)="ok()">Acknowledge</button>
</div>